import { axiosInstance } from '@/shared/core';

import { IPublisher } from '../model/types';

export const getPublishers = async (): Promise<IPublisher> => {
  return (await axiosInstance.get<IPublisher>('/publisher/getAll')).data;
};

export const getPublisherById = async (id: string): Promise<IPublisher> => {
  const response = await axiosInstance.get<IPublisher>(`/publisher/get/${id}`);

  return response.data;
};

export const createPublishers = async (
  publisher: IPublisher,
): Promise<IPublisher> => {
  const response = await axiosInstance.post<IPublisher>(
    '/publisher/create',
    publisher,
  );
  return response.data;
};

export const updatePublishers = async (
  publisher: IPublisher,
): Promise<IPublisher> => {
  const response = await axiosInstance.put<IPublisher>(
    '/publisher/update',
    publisher,
  );
  return response.data;
};

export const deletePublishers = async (id: string): Promise<IPublisher> => {
  const response = await axiosInstance.delete<IPublisher>(
    `/publisher/delete/${id}`,
  );
  return response.data;
};
